import {Injectable} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {Observable} from "rxjs";
import {ModifyListItemDialogComponent} from "./modify-list-item.component";

@Injectable()
export class ListEditorService {
  public modifyListItem(listItem, metadata, title): Observable<any> {
    return ModifyListItemDialogComponent.showDialog(
      this.dialogService,
      {listItem, metadata, title},
    );
  }

  constructor(
    private dialogService: DialogService,
  ) {}
}
